@import '../../../constants/spacing.module.less';

.item-subtitle {
  margin-top: @space-4;
  color: var(--gray-637381);
}

.selected-address {
  margin-top: @space-4;
  color: var(--gray-637381);
}

.contact-details-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: @space-4;
  color: var(--gray-637381);
}

.pickup-date {
  display: flex;
  flex-direction: column;
}
.pickup-window-times {
  display: flex;
  align-items: center;
  gap: @space-12;
}

.pickup-window-to-label {
  flex-shrink: 0;
}

.fixed-window-label {
  display: flex;
  align-items: center;

  .info-icon {
    margin-left: @space-4;
    width: 16px;
    height: 16px;
    fill: var(--gray-637381);
  }
}

.access-code-section {
  display: flex;
  flex-direction: column;
  gap: @space-8;
  margin-bottom: @space-24;
  font-size: 14px;
}

.accessCodeInput {
  left: @space-24;
  width: calc(100% - @space-24);
}

.instructions-textarea {
  width: 100%;
  resize: vertical;
  min-height: 80px;
  font-size: 14px;
}
